export default __webpack_public_path__ + "static/media/Dollar.91c84150.svg";